import { Icon, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core"
import React from "react"

import { ConvertDLSettings, CopyHelper, reduceEspString } from "../../classes/Helper"
import JSONTree from "../../components/JSONTree"
import GateWaysTable from "./GateWaysTable"
import MacTable from "./MacTable"



function processRowData(data) {
  if (data.PhyPayloadJson && data.PhyPayloadJson.length > 0) {
    data.phyStr = data.PhyPayloadJson
    data.PhyPayloadJson = JSON.parse(data.PhyPayloadJson)
  }

  if (data.rxInfo) {
    data.RxInfo = JSON.parse(JSON.stringify(data.rxInfo))
  }

  if (data.txInfo && data.txInfo.length > 0) {
    data.txInfoStr = data.txInfo
    data.txInfo = JSON.parse(data.txInfo)
  }

  data.fPort = ""
  if (data.PhyPayloadJson && data.PhyPayloadJson.macPayload && data.PhyPayloadJson.macPayload.fPort) {
    data.fPort = data.PhyPayloadJson.macPayload.fPort
  }

  if (data.PhyPayloadJson && data.PhyPayloadJson.macPayload && data.PhyPayloadJson.macPayload.fhdr) {
    if (data.PhyPayloadJson.macPayload.fhdr.fCtrl) {
      data.fCtrl = data.PhyPayloadJson.macPayload.fhdr.fCtrl
    }
    if (data.PhyPayloadJson.macPayload.fhdr.fOpts) {
      data.macCommands = data.PhyPayloadJson.macPayload.fhdr.fOpts
    }
    if (data.PhyPayloadJson.macPayload.frmPayload && data.PhyPayloadJson.macPayload.frmPayload.length > 0 && data.PhyPayloadJson.macPayload.frmPayload[0].cid) {
      let arr = data.PhyPayloadJson.macPayload.frmPayload
      if (data.macCommands) {
        data.macCommands = [...data.macCommands, ...arr]
      } else {
        data.macCommands = arr
      }
    }
  }
  if (data.PhyPayloadJson && data.PhyPayloadJson.macPayload && data.PhyPayloadJson.macPayload.cFlist) {
    let arr = [
      {
        cid: "",
        payload: {
          homeNetID: data.PhyPayloadJson.macPayload.homeNetID,
          devAddr: data.PhyPayloadJson.macPayload.devAddr,
          rxDelay: data.PhyPayloadJson.macPayload.rxDelay,
          RX1DROffset: ConvertDLSettings(4, 8, data.PhyPayloadJson.macPayload.dlSettings),
          RX2DataRate: ConvertDLSettings(0, 4, data.PhyPayloadJson.macPayload.dlSettings),
          Channels: data.PhyPayloadJson.macPayload.cFlist.payload.Channels,
        },
      },
    ]
    if (data.macCommands) {
      data.macCommands = [...data.macCommands, ...arr]
    } else {
      data.macCommands = arr
    }
  }

  if (data.macCommands && data.macCommands.length > 0) {
    data.macCommands.map((el) => {
      if (el.payload && el.payload.dlSettings) {
        el.payload.RX1DROffset = ConvertDLSettings(4, 8, el.payload.dlSettings)
        el.payload.RX2DataRate = ConvertDLSettings(0, 4, el.payload.dlSettings)
        el.payload.dlSettings = undefined
      }

      return el
    })
  }

  if (!data.mic && data.PhyPayloadJson) {
    data.mic = data.PhyPayloadJson.mic
  }

  if (data.esp) {
    data.esp = reduceEspString(data.esp)
  }

  return data
}

export default function LoggerRow(props) {
  let data = props.data

  if (!data) {
    return null
  }

  const id = "J" + Math.ceil(Math.random() * 10000000000000000)

  data = processRowData(data)
  let display
  if (props.expandAll) {
    display = "table-row"
  } else {
    display = "none"
  }

  return (
    <>
      <TableRow hover style={{ cursor: "pointer" }}>
        <TableCell id={id} className={"cell "} onClick={props.handleToggleClick}>
          <Icon style={{ fontSize: 15, verticalAlign: "middle" }} className="fa fa-plus-circle" />
        </TableCell>
        {props.fields &&
          props.fields.map((field, i) => (
            <TableCell key={i} className={"cell pd"} style={field.cell.style ? field.cell.style(data) : undefined}>
              {field.cell.render(data)}
            </TableCell>
          ))}
      </TableRow>
      <TableRow className={id} id={"extended"} style={{ display: display }}>
        <TableCell colSpan={props.fields.length}>
          <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ width: "max-content", display: "flex", flexDirection: "column" }}>
              <Table>
                <TableBody>
                  {data.mType && (
                    <TableRow hover style={{ cursor: "pointer" }}>
                      <TableCell className={"cell pd"}>
                        <span>
                          <b>MType:</b>
                        </span>
                      </TableCell>
                      <TableCell className={"cell pd"}>
                        <span>{data.mType} </span>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow hover style={{ cursor: "pointer" }}>
                    <TableCell className={"cell pd"}>
                      <span>
                        <b>Info:</b>
                      </span>
                    </TableCell>
                    <TableCell className={"cell pd"}>
                      {data && data.frmPayload && <span> Data size (bytes): {data.frmPayload.length / 2}, </span>}
                      {(data.airtime || data.airtime !== 0) && <span>Airtime (s): {data.airtime}, </span>}
                      {data.late !== undefined && <span>Late: {data.late} </span>}
                    </TableCell>
                  </TableRow>
                  {data.fCtrl && (
                    <TableRow hover style={{ cursor: "pointer" }}>
                      <TableCell className={"cell pd"}>
                        <span>
                          <b>FCtrl:</b>
                        </span>
                      </TableCell>
                      <TableCell className={"cell pd"}>
                        <span>
                          {Object.keys(data.fCtrl).map((item, index) => {
                            let val = data.fCtrl[item]
                            if (val) {
                              val = 1
                            } else {
                              val = 0
                            }
                            return item.replace("adr", "ADR") + ":" + val + (index === Object.keys(data.fCtrl).length - 1 ? "" : ", ")
                          })}
                        </span>
                      </TableCell>
                    </TableRow>
                  )}
                  {data && data.macCommands && <MacTable macCommands={data.macCommands} />}
                  {data && data.frmPayload && (
                    <TableRow hover style={{ cursor: "pointer" }}>
                      <TableCell className={"cell pd"}>
                        <span>
                          <b>Data (hex):</b>
                        </span>
                      </TableCell>
                      <TableCell className={"cell pd"}>
                        <div style={{ overflowWrap: "anywhere", maxWidth: "565px" }}>
                          <span style={{ whiteSpace: "pre-wrap" }} onDoubleClick={CopyHelper}>
                            {data.frmPayload}
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                  {data && data.rxInfo.length > 0 && (
                    <TableRow hover style={{ cursor: "pointer" }}>
                      <TableCell className={"cell pd"}>
                        <span>
                          <b>GWs Table with rows:</b>
                        </span>
                      </TableCell>
                      <TableCell className={"cell"}>
                        <div style={{ width: "max-content" }}>
                          <Table style={{ border: "1px solid #ccc" }}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={"cell pd after"}>GW ID</TableCell>
                                <TableCell className={"cell pd after"}>ESP</TableCell>
                                <TableCell className={"cell pd after"}>RSSI</TableCell>
                                <TableCell className={"cell pd after"}>SNR</TableCell>
                                <TableCell className={"cell pd after"}>TimeStamp UTC</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <GateWaysTable dateTime={data.dateTime} tableRxInfo={data.rxInfo} />
                            </TableBody>
                          </Table>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                  {data && data.txInfo && data.txInfo.frequency && (
                    <TableRow hover style={{ cursor: "pointer" }}>
                      <TableCell className={"cell pd"}>
                        <span>
                          <b>Frequency (MHz):</b>
                        </span>
                      </TableCell>
                      <TableCell className={"cell pd"}>
                        <span>{data.txInfo.frequency / 1e6}</span>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            <div style={{ width: "100%", display: "flex" }}>
              {data && data.rxInfo && data.rxInfo.length > 0 && (
                <div style={{ marginRight: "30px" }}>
                  <JSONTree shouldExpandNode={() => false} data={{ rxInfo: data.rxInfo }} />
                </div>
              )}

              {data && data.PhyPayloadJson && (
                <div style={{ marginRight: "30px" }}>
                  <JSONTree shouldExpandNode={() => false} data={{ PhyPayloadJson: JSON.parse(data.phyStr) }} />
                </div>
              )}

              {data && data.txInfo && (
                <div style={{ marginRight: "30px" }}>
                  <JSONTree shouldExpandNode={() => false} data={{ txInfo: JSON.parse(data.txInfoStr) }} />
                </div>
              )}
            </div>
          </div>
        </TableCell>
      </TableRow>
    </>
  )
}
